export const PEOPLE_COMPANY_DOCUMENT_FORMAT = {
	UPLOAD: 'upload',
	RICH_TEXT: 'richText',
	FORM: 'form',
};

const PEOPLE_COMPANY_DOCUMENT_IMAGE_EXTENSIONS = new Set([
	'png',
	'jpg',
	'jpeg',
	'webp',
]);

const normalizeFormatValue = (value) => (
	String(value || '').toLowerCase().replace(/[^a-z]/g, '')
);

export const normalizePeopleCompanyDocumentFormat = (value) => {
	const normalized = normalizeFormatValue(value);
	if (!normalized) {
		return null;
	}

	if (normalized === 'upload' || normalized === 'file') {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.UPLOAD;
	}

	if (normalized === 'richtext' || normalized === 'rich') {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.RICH_TEXT;
	}

	if (normalized === 'form' || normalized === 'questionnaire') {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.FORM;
	}

	return null;
};

export const isPeopleCompanyDocumentFormFormat = (value) => (
	normalizePeopleCompanyDocumentFormat(value) === PEOPLE_COMPANY_DOCUMENT_FORMAT.FORM
);

export const resolvePeopleCompanyDocumentMode = (document) => {
	const normalized = normalizePeopleCompanyDocumentFormat(document?.format);
	if (normalized) {
		return normalized;
	}

	const formQuestionCount = Array.isArray(document?.formConfig?.questions)
		? document.formConfig.questions.length
		: 0;
	if (formQuestionCount) {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.FORM;
	}

	if (document?.s3Key) {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.UPLOAD;
	}

	if (document?.contentHtml) {
		return PEOPLE_COMPANY_DOCUMENT_FORMAT.RICH_TEXT;
	}

	return PEOPLE_COMPANY_DOCUMENT_FORMAT.UPLOAD;
};

const resolvePeopleCompanyDocumentFileExtension = (s3Key) => {
	const key = String(s3Key || '').trim().toLowerCase();
	if (!key) {
		return '';
	}

	const [keyWithoutQuery = ''] = key.split('?');
	const [sanitizedKey = ''] = keyWithoutQuery.split('#');
	const [extension = ''] = sanitizedKey.split('.').slice(-1);
	return extension;
};

export const resolvePeopleCompanyDocumentDisplayFormat = (document) => {
	const documentMode = resolvePeopleCompanyDocumentMode(document);

	if (documentMode === PEOPLE_COMPANY_DOCUMENT_FORMAT.FORM) {
		return 'Form (questions)';
	}

	if (documentMode === PEOPLE_COMPANY_DOCUMENT_FORMAT.RICH_TEXT) {
		return 'RTE';
	}

	const fileExtension = resolvePeopleCompanyDocumentFileExtension(document?.s3Key);
	if (fileExtension === 'pdf') {
		return 'PDF';
	}

	if (PEOPLE_COMPANY_DOCUMENT_IMAGE_EXTENSIONS.has(fileExtension)) {
		return 'Image';
	}

	return 'File';
};
